module.exports = __webpack_public_path__ + "staticcomp/img/content_4.7e36dc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/10/content_4.jpg
// module id = ihfW
// module chunks = 39